module.exports = __webpack_public_path__ + "img/welding-11.dd6bf8e6.jpg";